function flattenObject(item, prefix = '') {
  const flattened = {};

  Object.keys(item).forEach(key => {
    const value = item[key];
    const fieldName = `${prefix}${prefix ? '.' : ''}${key}`;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      Object.assign(flattened, flattenObject(value, fieldName));
    } else {
      flattened[fieldName] = value;
    }
  });

  return flattened;
}

module.exports = { flattenObject };
